import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Privacy = () => {
  useEffect(() => {
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>
        <section className="ul-breadcrumb ul-section-spacing" style={{backgroundImage: "url('/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg')"}}>
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Privacy Policy</h2>
            <ul className="ul-breadcrumb-nav">
              <li><Link to="/">Home</Link></li>
              <li><span className="separator"><i className="flaticon-right"></i></span></li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </section>

        <section className="ul-section-spacing">
          <div className="ul-container">
            <div style={{maxWidth: '900px', margin: '0 auto'}}>

              <div style={{marginBottom: 'clamp(20px, 2.1vw, 30px)'}}>
                <p style={{fontSize: 'clamp(14px, 0.95vw, 16px)', color: 'rgba(0,0,0,0.5)'}}>Effective Date: January 29, 2026</p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>1. Overview</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Pathio is committed to protecting the privacy of our visitors and donors. This Privacy Policy explains what information we collect, how we use it, and your rights regarding your personal data.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>2. Information We Collect</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)', marginBottom: 'clamp(10px, 1.05vw, 15px)'}}>We may collect the following types of information:</p>
                <ul style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 2, color: 'rgba(0,0,0,0.7)', paddingLeft: 'clamp(20px, 2.1vw, 30px)'}}>
                  <li>Contact information you provide (name, email address).</li>
                  <li>Donation transaction data (amount, date, payment method).</li>
                  <li>Usage data collected automatically (IP address, device type, pages viewed).</li>
                  <li>Information submitted through our contact form or newsletter signup.</li>
                </ul>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>3. How We Use Your Information</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)', marginBottom: 'clamp(10px, 1.05vw, 15px)'}}>We use the information we collect to:</p>
                <ul style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 2, color: 'rgba(0,0,0,0.7)', paddingLeft: 'clamp(20px, 2.1vw, 30px)'}}>
                  <li>Operate and improve our website.</li>
                  <li>Process donations and send tax receipts.</li>
                  <li>Respond to inquiries submitted through our contact form.</li>
                  <li>Send updates or newsletters when you opt in.</li>
                  <li>Comply with legal obligations.</li>
                </ul>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)', marginTop: 'clamp(10px, 1.05vw, 15px)'}}>
                  We do not sell, rent, or share your personal data with third parties for marketing purposes.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>4. Cookies and Tracking</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Our site may use cookies and similar technologies for analytics and to improve your experience. You can control cookies through your browser settings. Third-party services (e.g., Google Analytics) may place their own cookies to help us understand site usage.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>5. Third-Party Services</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  We may share information with trusted service providers that support our operations, such as payment processors and email providers. These partners are contractually required to protect your personal information and may only use it for the purposes we specify.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>6. Payment Information</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  We do not store credit card numbers or full payment details on our servers. All payment processing is handled securely by third-party providers (e.g., Stripe). Please refer to their privacy policies for more information on how they handle your data.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>7. Your Rights</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)', marginBottom: 'clamp(10px, 1.05vw, 15px)'}}>You have the right to:</p>
                <ul style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 2, color: 'rgba(0,0,0,0.7)', paddingLeft: 'clamp(20px, 2.1vw, 30px)'}}>
                  <li>Request access to the personal data we hold about you.</li>
                  <li>Request correction of inaccurate data.</li>
                  <li>Request deletion of your personal data.</li>
                  <li>Opt out of marketing communications at any time.</li>
                </ul>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)', marginTop: 'clamp(10px, 1.05vw, 15px)'}}>
                  To exercise any of these rights, contact us at{' '}
                  <a href="mailto:pathio.org@gmail.com" style={{color: 'var(--ul-primary)', textDecoration: 'none'}}>pathio.org@gmail.com</a>.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>8. Data Security</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  We implement reasonable security measures to protect your personal data from unauthorized access, alteration, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>9. Children's Privacy</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  Our website is not directed at children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us and we will take steps to delete it.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>10. Changes to This Policy</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.
                </p>
              </div>

              <div style={{marginBottom: 'clamp(35px, 3.15vw, 50px)'}}>
                <h3 style={{fontSize: 'clamp(20px, 1.47vw, 24px)', fontWeight: 700, color: 'var(--ul-black)', marginBottom: 'clamp(12px, 1.05vw, 18px)'}}>11. Contact</h3>
                <p style={{fontSize: 'clamp(15px, 1.05vw, 17px)', lineHeight: 1.8, color: 'rgba(0,0,0,0.7)'}}>
                  If you have any questions about this Privacy Policy, please contact us at{' '}
                  <a href="mailto:pathio.org@gmail.com" style={{color: 'var(--ul-primary)', textDecoration: 'none'}}>pathio.org@gmail.com</a>.
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Privacy;
